import "../richTextContentElement/RichTextContent.css.ts.vanilla.js";
import "../rootElement/Root.css.ts.vanilla.js";
import "./Profile.css.ts.vanilla.js";
var t = "_1qvs4rw2", e = "_1qvs4rw0", i = "_1qvs4rw1", s = "_1qvs4rw5", q = "_1qvs4rw7", w = "_1qvs4rw4", _ = "_1qvs4rw6", o = "_1qvs4rw3";
export {
  t as card,
  e as container,
  i as flex,
  s as image,
  q as profileChildren,
  w as subtitle,
  _ as text,
  o as title
};
